export default {
  "aor": {
    "action": {
      "add_filter": "Ajouter filtre",
      "back": "Retour",
      "cancel": "Annuler",
      "close": "Fermer",
      "create": "Créer",
      "delete": "Effacer",
      "edit": "Editer",
      "list": "Lister",
      "refresh": "Actualiser",
      "remove_filter": "Enlever ce filtre",
      "save": "Sauver",
      "show": "Montrer"
    },
    "auth": {
      "avatar": "Votre URL Photo (optionnel)",
      "bio": "Courte Biographie (optionnel)",
      "education": "Votre Education (optionnel)",
      "email": "Adresse Email",
      "first_name": "Prénom (optionnel)",
      "last_name": "Nom de Famille (optionnel)",
      "logged_in": "Connecté",
      "logged_out": "Deconnecté",
      "logging_in": "Connecté",
      "login": "S'identifier",
      "logout": "Se déconnecter",
      "name": "Nom",
      "password": "Mot de Passe",
      "sign_in": "S'identifier",
      "sign_in_error": "Erreur d'authentification, veuillez réessayer",
      "sign_up": "Inscription",
      "sign_up_error": "Erreur d'inscription, veuillez réessayer",
      "signing_up": "Inscrit",
      "username": "Nom d'utilisateur",
      "website": "Votre site Web (optionnel)"
    },
    "boolean": {
      "false": "Non",
      "true": "Oui"
    },
    "edit_profile": "Editer le profile",
    "input": {
      "autocomplete": {
        "none": ""
      },
      "file": {
        "upload_several": "Déposer des fichiers à télécharger, ou cliquer pour en sélectionner un.",
        "upload_single": "Déposer un fichier à télécharger, ou cliquer pour le sélectionner."
      },
      "image": {
        "upload_several": "Déposer des images à télécharger, ou cliquer pour en sélectionner une.",
        "upload_single": "Déposer une image à télécharger, ou cliquer pour la sélectionner."
      }
    },
    "message": {
      "about": "A propos",
      "are_you_sure": "Etes-vous sûr?",
      "no": "Non",
      "not_found": "Soit vous avez tapé une mauvaise adresse URL, soit vous avez suivi un mauvais lien.",
      "yes": "Oui"
    },
    "navigation": {
      "next": "Suivant",
      "no_more_results": "Aucun autre résultat trouvé",
      "no_results": "Cette entité n'a pas été modifiée: pas d'historique à afficher",
      "page_out_from_begin": "Ne peut pas aller avant la page 1",
      "page_out_from_end": "Ne peut pas aller après la dernière page",
      "page_out_of_boundaries": "Numéro de page %{page} hors limites",
      "page_range_info": "%{offsetBegin}-%{offsetEnd} du %{total}",
      "prev": "Préc"
    },
    "notification": {
      "created": "Créé avec succès",
      "deleted": "Effacé avec succès",
      "http_error": "Erreur de communication avec le serveur",
      "item_doesnt_exist": "L'élément n'existe pas",
      "updated": "Mis à jour avec succès"
    },
    "page": {
      "create": "Créer %{name}",
      "dashboard": "Tableau de bord",
      "delete": "Effacer %{name} #%{id}",
      "edit": "%{name} #%{id}",
      "list": "%{name} Lister",
      "not_found": "Pas trouvé",
      "show": "%{name} #%{id}"
    },
    "profile_image": "Avatar",
    "validation": {
      "email": "Doit être un email valide",
      "maxLength": "Doit avoir %{max} charactères ou moins",
      "maxValue": "Doit être %{max} ou moins",
      "minLength": "Doit avoir %{min} characters au moins",
      "minValue": "Doit être au moins %{min}",
      "number": "Doit être un numéro",
      "required": "Requis"
    }
  },
  "askQuestion": "Poser une question",
  "auth": {
    "logged_in": "Connecté",
    "logged_out": "Deconnecté",
    "login": "S'identifier",
    "logout": "Se deconnecter",
    "sign_in": "S'identifier",
    "sign_up": "Inscription"
  },
  "chartSunburst": {
    "breakdownTitle": "Panne de %{dontTranslate} sujets",
    "hoverClickItems": "survoler / cliquer sur des éléments",
    "switchChart": "TABLEAU DE COMMUTATION"
  },
  "community": {
    "biographyShort": "Courte Biographie",
    "board": "Tableau",
    "highscore": "Meilleur Score des données de Membre",
    "memberSince": "membre depuis",
    "myProfile": "Mon Profil",
    "supportingMember": "Contributeurs"
  },
  "didYouKnow": {
    "coloring": "Vous pouvez modifier la couleur de la carte en fonction de la religion, de la culture ou de la population via licône Calques de la barre de menus ",
    "discover": "Vous pouvez parcourir les images et autres supports en cliquant sur licône Compas dans la barre de menus",
    "distribution": "Vous pouvez voir une distribution complète des personnes d'un royaume en cliquant sur l'icône représentant un cercle sur un article",
    "link": "Vous pouvez relier tous les articles pour les afficher dans une section de contenu (articles) ou dans la section médias",
    "markerlimit": "Vous pouvez améliorer les performances en diminuant le nombre de marqueurs via l'icône des calques dans la barre de menus",
    "province": "Vous pouvez voir l'historique complet d'une province en cliquant sur Province dans l'en-tête de l'article",
    "question": "Vous pouvez poser des questions sur des articles et répondre aux autres sur le forum",
    "timeline": "Vous pouvez faire défiler la timeline à léchelle avec la souris"
  },
  "introHints": {
    step1: "Faites défiler pour zoomer et cliquez n'importe où sur la timeline (1/3)",
    step2: "Ouvrez le menu Calques et sélectionnez des marqueurs et des épopées (2/3)",
    step3: "Ouvrez le menu Média pour parcourir les images, vidéos, etc. liées à lannée sélectionnée (3/3)",
    stepFinal: "Ce sont les bases. De nombreuses autres fonctionnalités vous attendent. Profiter du voyage!",
    close: "Fermer l'introduction"
  },
  benchmarkPage: {
    title: "Paramètres par défaut",
    tier1Header: "Propre et Rapide",
    tier1Description: "Seulement les bordures de carte et les étiquettes.",
    tier2Header: "Intermédiaire",
    tier2Description: "Bordures, étiquettes et 2000 marqueurs maximum par an.",
    tier3Header: "Achevé",
    tier3Description: "Des épopées dans la chronologie et un maximum de 5000 marqueurs par an.",
    hint: "Ne vous inquiétez pas, vous pouvez également personnaliser tous les paramètres ultérieurement!"
  },
  "loadingPage": {
    "errorMessage": "Chronas semble être trop sollicité pour le moment. Veuillez réessayer dans quelques minutes.",
    "loadingScreenDescription": {
      "218": "Le jeune empereur romain Elagabalus (203-222 après JC) accueillant un banquet",
      "400": "Honorius, fils de Theodosius Ier; nommé Augustus junior pour l'ouest par Theodosius en 393",
      "450": "450-511: Education des enfants de Clovis",
      "711": "711: Bataille de Guadalete des Wisigoths et début de la conquête omeyyade de l'Hispanie",
      "881": "881: Bataille des forces danoises des guerriers paking vikings et des troupes chrétiennes Carolingienne",
      "1121": "1121: Les suites de la bataille de Didgori décrites dans \"L'Esprit du cavalier\" de Augusto Ferrer-Dalmau",
      "1331": "1331: Le siège d'Akasaka près d'Osaka fut l'une des premières batailles de la guerre de GenkÅ",
      "1582": "1582: Bataille du Cap Tchouvache",
      "1627": "1627-1628: Siège de La Rochelle (Royaume de France)",
      "1649": "1649: Cromwell à Dunbar. Oliver Cromwell a uni l'ensemble des îles britanniques par la force et a créé le Commonwealth d'Angleterre",
      "1832": "1832: Pont Neuf à Paris",
      "1862": "1862: Prisonniers confédérés capturés lors de la bataille de Front Royal",
      "1871": "1871: Proclamation de l'Empire Germanique à Versailles",
      "-1400": "1400 av. J.-C.: le char solaire de Trundholm est un artefact nordique de l'âge du bronze découvert au Danemark.",
      "-2000": "26ème siècle avant JC: Le Standard d'Ur, une boîte en bois creuse avec des scènes de guerre et de paix",
      "-332": "332 avant notre ère: l'entrée incontestée d'Alexandre le Grand dans la ville de Babylone",
      "-519": "519 av. J.-C.: Lucius Quinctius devint un opposant légendaire romain des droits des plébéiens (citoyens ordinaires)",
      "-52": "52 avant notre ère: La reddition du chef gaulois après la bataille d'Alésia",
      "-600": "605-562 avant notre ère: Lion qui se promenait, empire néo-babylonien",
      "-620": "620-570 avant notre ère: Sappho et Alcaeus",
      "-668": "668 avant notre ère: reliefs sculptés représentant Ashurbanipal, le dernier grand roi assyrien, chassant des lions"
    }
  },
  "pos": {
    "about": "A propos de Chronas",
    "account": "Gérer son compte",
    "addMedia": "Ajouter des Medias",
    "advanced": "Avancé",
    "area": "Région",
    "areas": "Régions",
    "back": "retour",
    "basemap": "Fond de carte",
    "basemapTypes": {
      "none": "Aucun",
      "topographic": "Topographie",
      "watercolor": "Aquarelle"
    },
    "block": {
      "about1": "<h4>Qu'est-ce que Chronas?</h4> <br /> <h5>In Brief</h5>",
      "about2": "Chronas peut être décrit comme un mélange de <a target='_blank' href='https://www.openstreetmap.org'>Carte Open  Street</a>, <a target='_blank' href='https://www.wikipedia.org/'>Wikipedia</a> et <a\n                    target='_blank' href='https://earth.google.com/web/'>Google Earth</a>. Il cartographie 4000 ans d'histoire\n                  les dirigeants (entités politiques), les cultures et les religions sur une carte renvoyant à des articles connexes de Wikipedia\n                  ainsi que divers types de marqueurs différents tels que des personnes, des batailles, des villes, des châteaux, etc. Tous\n                  peuvent être liées pour exprimer une relation entre elles (par exemple en reliant le siège dune ville au\n                  marqueur de ville spécifique). En plus de cela, dautres types de supports tels que des vidéos, des images ou des podcasts peuvent être liés \n                  pour créer un réseau de connaissances encore plus grand. Les utilisateurs peuvent évaluer, éditer et ajouter de nouveaux marqueurs, entités de zone\n                  ou éléments multimédias et créer des liens, tous suivis par un système dhistorique des révisions. Ils peuvent aussi demander\n                  des questions sur des articles spécifiques et créer des recueils d'articles (appelés Epics) sur des sujets majeurs tels que\n                  guerres ou explorations (toutes les entités de zone sont sur des Epics par défaut). Une vidéo présentant ces fonctionnalités est\n                  disponible",
      "about3": "ici",
      "about4": "<h5>Depuis le début</h5>\n                <p>Le nom <b>Chronas</b> est une combinaison de<b>Chron</b>os et Atl<b>as</b> indicant le\n                  approche chronologique et cartographique de l'application de l'histoire.</p>\n                <p>À la mi-2014, lidée initiale était dajouter un curseur temporel à une application de type Google Maps, ce qui en faisait\n                  possible de voyager dans le temps: regarder des royaumes se créer, grandir et disparaître à nouveau. Le but était\n                  pour mieux comprendre comment l'histoire du monde est interconnectée. <i>Qu'est-il arrivé en Asie\n                    quand Rome a dominé l'Europe? Que s'est-il passé en Arabie quand Kublai Khan s'est proclamé empereur\n                    de Chine?</i></p>\n                <p>La version originale de Chronas a été publiée en 2015 et a attiré plus de 5 000 utilisateurs enregistrés. C'était\n                  basé sur une fourchette de <a target='_blank' href='https://umap.openstreetmap.fr/en'>Open Street Map</a> et\n                  utilisé la bibliothèque de cartes raster <a target='_blank' href='https://leafletjs.com/'>Leaflet</a> avec la\n                  relationnelle <a target='_blank' href='https://www.postgresql.org/'>PostgreSQL</a> banque de données.\n                </p>\n                <p>\n                  Voici une vidéo de ~ 5 min montrant les caractéristiques de base de la version originale:\n                </p>",
      "about5": "<p>\n                  Si vous souhaitez essayer la version originale, elle est toujours disponible à l'adresse <a target='_blank'\n                    href='http://v0.chronas.org'>http://v0.chronas.org</a>.\n                  Il comprend également le <a target='_blank' href='http://v0.chronas.org/blog'>blog de développement</a> which\n                  explique plus en détail l'approche technique de la version initiale ainsi que deux applications 3D dérivées\n                  montrant<a target='_blank' href='http://app.chronas.org/castles/#/wikidata'>châteaux</a> et <a\n                    target='_blank' href='http://app.chronas.org/battles/#/wikidata'>batailles</a> parlanguage wikipedia.\n                </p>\n                <br />\n                <p>\n                  Le développement de la version actuelle de Chronas a débuté en juillet 2017 et a représenté une réécriture complète de\n                  la logique et l'architecture centrées sur l'amélioration des performances, ainsi que sur la facilité d'édition, de révision et de mise en relation\n                  des Articles Liés. À la place de Leaflet, la bibliothèque de cartes WebGL <a target='_blank'\n                    href='https://www.mapbox.com/mapbox-gl-js/api/'>Mapbox\n                  GL</a> a été utilisé avec une <a target='_blank' href='https://reactjs.org/'>React JS</a> UI. Pour l'arrièe-plan\n                  une API dédiée écrite en <a target='_blank' href='https://expressjs.com'>Express</a> <a\n                    target='_blank' href='https://nodejs.org/'>Node JS</a> utilise un NoSQL <a target='_blank'\n                      href='https://nodejs.org/'>La base de données </a> Mongo\n                  pour les requêtes complexes et la révision.\n                </p>\n                <p>Vous trouverez une description détaillée de la nouvelle version de Chronas dans la <b>section</b> comment faire.</p>",
      "contact1": "Développeurs",
      "contact10": "Envoyer",
      "contact2": "Développement avant et arrière-plan",
      "contact3": "DevOps et support de développement",
      "contact4": "Traductions par",
      "contact5": "Contact",
      "contact6": "Envoyez-nous un courriel directement (survolez l'icône de courriel pour afficher nos adresses électroniques) ou utilisez le formulaire ci-dessous:",
      "contact7": "Votre adresse email*",
      "contact8": "Sujet*",
      "contact9": "Message*",
      "howTo1": "Comment utiliser en 5 minutes environ",
      "howTo2": "Comment éditer les données en 6 minutes environ (avec commentaire anglais)",
      "pledge1": "Vous avez maintenant été sur Chronas pour plus de <b>15 minutes</b>!",
      "pledge2": "Chronas dépend du soutien des utilisateurs pour survivre et grandir. Si vous trouvez ce projet utile, rendez-vous sur ",
      "pledge3": " et envisager de donner en gage un montant de votre choix.",
      "pledge4": "Les patrons seront en mesure de diriger le projet en votant sur les priorités des fonctionnalités et les principales décisions de conception.",
      "pledge5": " Apprenez à prononcer Si vous n'aimez pas utiliser Patreon, des contributions uniques sont possibles via PayPal:",
      "rules1": "<br />\n                <h4>Règles pour la conservation des données</h4>\n                <ol>\n                  <li><i>Pas de vandalisme</i>: Ce n'est pas l'endroit pour peindre une carte d'histoire alternative. Le vandalisme fait mal\n                    immensément au projet (sauvegardes coûteuses) et vous fera bannir.\n                  </li>\n                  <li><i>Regardez les vidéos de tutoriel</i> avant de commencer l'édition. Certains contrôles peuvent conduire\n                    à <i>des résultats</i> indésirables.\n                  </li>\n                  <li>Vos données doivent être basées sur <i>histoire acceptée</i> et vous devriez être prêt à citer\n                    les sources si demandé.\n                  </li>\n                  <li><i>Report</i> Utilisateurs qui enfreignent ces règles.</li>\n                </ol>\n                <br />\n                <h4>Règles pour les forums</h4>\n                <ol>\n                  <li><i>Pas de vandalisme</i>: Pas de racisme, de bigoterie ou de comportement offensant.</li>\n                  <li>Ask <i>Questions claires et spécifiques</i>, avec <i>Heure et lieu à l'esprit</i>.</li>\n                  <li>Fournir de préférence <i>Sources primaires et secondaires</i> Si demandé plutôt que des sources tertiaires\n                    Comme <i>Wikipedia</i>.\n                  </li>\n                  <li>Questions sérieuses sur le sujet seulement: <i>Pas de plaisanteries</i>, <i>Anecdotes</i>, <i>Désordre</i>, ou\n                    autre <i>Digressions</i>.\n                  </li>\n                  <li><i>Rapport</i> Des réponses qui enfreignent ces règles.</li>\n                </ol>",
      "statistics1": "Les statistiques suivantes sont des comptes de données en direct et représentent un instantané de la base de données Chronas actuelle",
      "statistics2": "Points de données cartographiques",
      "statistics3": "Utilisateurs et engagements",
      "statistics4": "Répartition des marqueurs",
      "statistics5": "Points de données cartographiques",
      "statistics6": "Détails",
      "statistics7": "Répartition des médias",
      "statistics8": "Utilisateurs par type d'authentification",
      "statisticsTooltip1": "Points de données géographiques: 4000 ans cartographiés avec 2479 provinces à 4 dimensions",
      "statisticsTooltip2": "Les marqueurs incluent les personnes et les marqueurs de combat, mais aussi les villes, etc.",
      "statisticsTooltip3": "Médias comprend les médias (vidéos, images ...) ainsi que les épopées (compilation d'articles)",
      "statisticsTooltip4": "Nombre d'entités géographiques uniques pour les dirigeants, les cultures et les religions",
      "statisticsTooltip5": "Utilisateurs inscrits",
      "statisticsTooltip6": "Modifications apportées aux données par les utilisateurs",
      "statisticsTooltip7": "Fil de discussion (comprend les discussions générées automatiquement et migrées)",
      "statisticsTooltip8": "Commentaires du forum (comprend les réponses générées automatiquement et migrées)",
      "support1": "Il existe deux manières de financer lentretien et le développement de nouvelles fonctionnalités et la réparation des\n                  problèmes. Par exemple, Wikipedia ou des radiodiffuseurs publics utilisent des campagnes récurrentes pour collecter des dons (<b>pledge\n                  drives</b>), beaucoup d'applications web utilisent<b>annonces</b> (ce qui peut diminuer la facilité d'utilisation/\n                  de l'application). Une autre façon consiste à introduire une <b>version pro</b> ou essayer de trouver <b>investisseurs\n                  en capital risque</b>.",
      "support10": " les développeurs.",
      "support11": "Si vous êtes intéressé par l'exécution de Chronas sur votre (ou notre) serveur avec une réplique de données complète dont vous avez le contrôle complet, ",
      "support12": "contactez",
      "support13": " nous et nous sommes heureux de discuter plus en détail.",
      "support2": "Nous avons décidé dessayer un autre modèle de financement qui donne aux <b>utilisateurs qui assurent</b> \n                  lavenir de Chronas la capacité de décider de lorientation du voyage. Si vous croyez en notre\n                  projet, s'il vous plaît envisager de nous soutenir sur",
      "support3": " où nous aurons des votes <b>réguliers</b> sur la priorité des <b>nouvelles fonctionnalités proposées</b> aussi que<b>sur les principales décisions de conception</b>.",
      "support4": "Si vous n'aimez pas utiliser Patreon, des contributions uniques sont possibles via PayPal:",
      "support5": "Nouvelles fonctionnalités",
      "support6": "Vous pouvez proposer des fonctionnalités dans la demande de fonctionnalité",
      "support7": "forum",
      "support8": " ou en contactant ",
      "support9": "directement",
      "welcome11": "<b>Chronas</b> est une application de carte d'histoire avec plus de ",
      "welcome12": "50 millions de points de données",
      "welcome13": " que chaque utilisateur enregistré peut gérer et contribuer (tout comme <a>Wikipedia</a>).",
      "welcome21": "Avant de plonger, veillez à regarder le court métrage ",
      "welcome22": "Tutoriel vidéo",
      "welcome23": " dans la section Comment.",
      "welcome31": "Joindre",
      "welcome32": " notre communauté de <b>%{dontTranslate}</b> membres pour ajouter et modifier des données, gagner des points, poser des questions sur les articles dhistoire et accéder à notre ",
      "welcome33": "Les forums",
      "welcome34": " suggérer de nouvelles fonctionnalités et signaler des bugs.",
      "welcome41": "Visiter le ",
      "welcome42": "À propos",
      "welcome43": " section pour en savoir plus sur le projet Chronas et envoyer aux développeurs vos questions, commentaires ou questions via le ",
      "welcome44": "formulaire",
      "welcome45": " de contact.",
      "welcome51": "Nous croyons au potentiel de ce projet de devenir un outil dhistoire populaire aux côtés de Wikipedia. Si vous partagez notre enthousiasme et souhaitez voir le projet aboutir, envisagez de devenir un soutien. Pour plus d'informations sur <b>le support</b> et <b>l'avenir de Chronas</b>, consultez la ",
      "welcome52": "section ",
      "welcome53": " Support."
    },
    "clusterMarker": "Marqueur de groupe",
    "community": "Conseil communautaire",
    "configuration": "Configuration",
    "discover": "Découvrir",
    "discover_component": {
      "edit": "Modifier cet article",
      "hasNoArticle": "Aucun article Wiki lié pour le moment, veuillez envisager de modifier cet élément",
      "hasNoSource": "Aucune source liée pour le moment, veuillez envisager de modifier cet élément",
      "openArticle": "Ouvrir un article lié à Wikipedia",
      "openSource": "Ouvrir la source dans un nouvel onglet",
      "tabs": {
        "HIGHLIGHTS": "POINTS FORTS",
        "ARTEFACTS": "ARTEFACTS",
        "EPICS": "EPOPEES",
        "PEOPLE": "PEUPLE",
        "CITIES": "VILLES",
        "BATTLES": "BATAILLES",
        "OTHER": "AUTRE",
        "VIDEOS": "VIDEOS",
        "PRIMARY SOURCES": "SOURCES PRIMAIRES"
      },
    },
    "discover_label": "Découvrez l'année ",
    "downvote": "Inapproprié, brisé ou inexact",
    "edit": "Modifier",
    "epicIdNameArray": {
      "ee": "Exploration",
      "ei": "Découverte",
      "eo": "Autre Epopée",
      "es": "Source Primaire",
      "ew": "Guerre"
    },
    "epics": "Epopées",
    "feedbackSuccess": "Merci d'avoir organisé les données!",
    "filterMedia": "Média filtrant",
    "fontType": "Type de police",
    "founded": "établi",
    "fullscreenArticle": "Article plein écran",
    "general": "Général",
    "goFullScreen": "Plein écran",
    "goTutorial": "Aller au tutoriel",
    "help": "Intro et information",
    "images": "Images",
    "info": {
      "followUs": "Suivez nous sur",
      "lastDataEdit": "dernière modification des données",
      "tabs": {
        "about": "A propos",
        "contact": "Contact",
        "howTo": "Comment",
        "rules": "Règles",
        "statistics": "Statistiques",
        "support": "Support",
        "welcome": "Bienvenue"
      },
      "welcomeTo": "Bienvenue à"
    },
    "information": "Information",
    "label": "Étiquette",
    "language": "Langue",
    "layers": "Couches",
    "linkedTypes": {
      "artefacts": "[Image] Artefact",
      "audios": "[Podcast & Audio]",
      "battles": "[Image] Bataille",
      "cities": "[Image] Ville et bâtiment",
      "eb": "[Epic] Biographie",
      "ee": "[Epic] Explorations",
      "ei": "[Epic] Découvertes",
      "eo": "[Epic] Autre",
      "ew": "[Epic] Guerres",
      "h": "[HTML ou Texte]",
      "misc": "[Image] Autre",
      "o": "Autre",
      "people": "[Image] Personne",
      "ps": "[Link] Source Primaire",
      "v": "[Video]",
      "w|a": "[Wiki Article] Peuple -> Artistes",
      "w|ar": "[Wiki Article] Artifacts",
      "w|at": "[Wiki Article] Peuple -> Athlètes",
      "w|b": "[Wiki Article] Batailles -> Batailles",
      "w|c": "[Wiki Article] Villes -> Villes",
      "w|ca": "[Wiki Article] Villes -> Châteaux",
      "w|e": "[Wiki Article] Peuple -> Explorateurs",
      "w|l": "[Wiki Article] Autre -> Point de repère",
      "w|m": "[Wiki Article] Peuple -> Militaire",
      "w|o": "[Wiki Article] Autre -> Inconnu",
      "w|op": "[Wiki Article] Peuple -> Non classé",
      "w|p": "[Wiki Article] Peuple -> Politiciens",
      "w|r": "[Wiki Article] Peuple -> Religieux",
      "w|s": "[Wiki Article] Peuple -> Scientifiques",
      "w|si": "[Wiki Article] Batailles -> Sièges"
    },
    "loading": "chargement...",
    "localeWikiNotFound": "Impossible de trouver l'article en français",
    "map": "",
    "markerIdNameArray": {
      "Artifact": "Artifact",
      "Artist": "Artistes",
      "Athlete": "Athlètes",
      "Battle": "Bataille",
      "Capital": "Capital",
      "Castle": "Château",
      "City": "Ville",
      "Explorer": "Exploreur",
      "Landmark": "Point de repère",
      "Military": "Militaire",
      "Politician": "Politiciens",
      "Religious": "Religieux",
      "Scientist": "Scientifiques",
      "Siege": "Siège",
      "Unclassified": "Non classé",
      "Unknown": "Inconnu"
    },
    "markerLimit": "Limite de marqueur",
    "markerMetadataTypes": {
      "a": "Artiste",
      "ae|culture": "Culture",
      "ae|religion": "Religion",
      "ae|religionGeneral": "Religion Générale",
      "ae|ruler": "Règle",
      "ar": "Artifact",
      "at": "Athlète",
      "b": "Bataille",
      "c": "Ville",
      "ca": "Château",
      "cp": "Capitale",
      "e": "Exploreur",
      "ee": "Exploration",
      "ei": "Découverte",
      "eo": "Autre Epopée",
      "es": "Source primaire",
      "ew": "Guerre",
      "l": "Point de repère",
      "m": "Militaire",
      "o": "Inconnu",
      "op": "Non classé",
      "p": "Politicien",
      "ps": "Source primaire",
      "r": "Religieux",
      "s": "Scientifique",
      "si": "Siège"
    },
    "markers": "Marqueurs",
    "markersMedia": "Marqueurs et médias",
    "markerType": "Type de marqueur",
    "markerTypes": {
      "abstract": "Abstrait",
      "themed": "À thème"
    },
    "mediaTitle": "Média: %{dontTranslate}",
    "metadata": "Métadonnées",
    "migration": "Migration",
    "migrationTooltip": "Affiche les itinéraires du lieu de naissance des personnes au lieu de décès et les agrégats par lieu.",
    "minimize": "Minimiser",
    "mod": "Modification",
    "next": "suivant",
    "noLinkedContents": "Il n'y a pas encore d'éléments de média liés, pensez à en ajouter et à en relier un.",
    "opacityByPopulation": "Opacité par population",
    "openArticle": "Article ouvert",
    "openEpic": "Ouvre son propre epic",
    "openImage": "Ouvre Image",
    "openSource": "Ouvre Source",
    "partOf": "Partie De",
    "pledgeOpen": "Ouvrir Patreon dans un nouvel onglet",
    "pledgeRemind": "Rappelle-moi dans 15 minutes",
    "pledgeTitle": "Hey voyageur!",
    "pointsAdded": "Points ajoutés à votre compte",
    "privacyPolicy": "Politique de confidentialité",
    "random": "Article aléatoire",
    "readDocument": "Lire le document",
    "related_item": "ARTICLES CONNEXES...",
    "resources": "Resources",
    "revisionHistory": "Historique des révisions",
    "revisions": "Révisions",
    "search": "Chercher",
    "searchMarkers": "Marqueurs de recherche",
    "setYearByArticle": "Définir l'année par article",
    "share": "Partager en tant que lien ou exporter une image",
    "showProvinces": "Afficher les provinces",
    "signupToGatherPoints": "Inscrivez-vous pour obtenir des points pour vos curations",
    "skipTutorial": "Je sais ce que je fais (sauter le tutoriel)",
    "startTyping": "Commencer à écrire",
    "statistics": {
      "area": "Zone",
      "edits": "Édite",
      "entities": "Entités",
      "markers": "Marqueurs",
      "media": "Média",
      "replies": "Réponses",
      "threads": "Fils",
      "users": "Utilisateurs"
    },
    "termsofService": "Conditions d'utilisation",
    "theme": {
      "dark": "Sombre",
      "font": "Police de caractère",
      "light": "Clair",
      "luther": "Concordia",
      "marker": "Marqueur",
      "name": "Thème"
    },
    "timeline": {
      "expand": "Développer la chronologie",
      "reset": "Réinitialiser l'affichage de la chronologie",
      "searchEpics": "Recherche Epics"
    },
    "toggle": "Basculer",
    "upvote": "Intéressant et précis",
    "users": "Gérer les utilisateurs",
    "welcome": "Bienvenue"
  },
  "resources": {
    "areas": {
      "fields": {
        "capital": "Capitale",
        "color": "Couleur de la zone",
        "culture": "Culture",
        "display_name": "Afficher un nom",
        "endYear": "Jusqu'à l'année",
        "genReligion": "Religion générale",
        "icon_url": "Icône (URL complète .wikimedia ou Wikipedia)",
        "key": "Clé d'entité",
        "main_religion_name": "Nom principal de religion",
        "main_ruler_name": "Nom de la règle principale",
        "population": "Population",
        "province": "Province",
        "province_list": "Cliquez sur les provinces pour sélectionner / désélectionner",
        "religion": "Religion",
        "religionGen": "Religion Gen.",
        "replaceWith": "Remplacer par",
        "ruler": "Règle",
        "search_name": "Sélectionnez par nom",
        "startYear": "À partir de l'année",
        "wiki_url": "Article (URL complète de Wikipedia)"
      }
    },
    "categories": {
      "fields": {
        "products": "Produits"
      },
      "name": "Catégorie |||| Les catégories"
    },
    "commands": {
      "fields": {
        "basket": {
          "delivery": "Livraison",
          "quantity": "Quantité",
          "reference": "Référence",
          "sum": "Somme",
          "tax_rate": "Taux d'imposition",
          "total": "Total",
          "unit_price": "Prix ??unitaire"
        },
        "customer_id": "Client",
        "date_gte": "Passé depuis",
        "date_lte": "Passé avant",
        "total_gte": "Montant minimum"
      },
      "name": "Ordre |||| Ordres"
    },
    "linked": {
      "fields": {
        "content": "Description",
        "description": "Titre",
        "geojson": "Geojson (pour epics)",
        "onlyEpicContent": "Utilisé uniquement comme partie liée d'un autre article (vous serez redirigé vers le formulaire de lien lors de la sauvegarde)",
        "poster": "Lien vers l'image de l'affiche",
        "source": "Lien vers la source",
        "src": "Lien vers la source/ ID",
        "subtype": "Type",
        "wiki": "Article Wikipedia associé",
        "year": "Année"
      }
    },
    "links": {
      "fields": {
        "content_list": "Éléments devant apparaître dans la section de liste de contenu de gauche",
        "media_list": "Éléments devant apparaître dans la section des médias",
        "source": "Article source recevant des liens"
      }
    },
    "markers": {
      "deleted": "Marqueur supprimé",
      "fields": {
        "capitalEnd": "Fin d'année",
        "capitalOwner": "Souverain",
        "capitalStart": "Année de début",
        "coo": "Coordonnées",
        "date": "Date",
        "endYear": "Fin de l'année",
        "lastUpdated": "Dernière mise à jour",
        "lat": "Latitude",
        "lng": "Longitude",
        "name": "Nom",
        "rating": "Évaluation",
        "startYear": "Année de début",
        "subtype": "Sous-type",
        "type": "Type",
        "url": "URL",
        "year": "Année"
      },
      "name": "Marqueur |||| Marqueurs",
      "place_marker": "Placer un marqueur",
      "tabs": {
        "address": "Adresse",
        "identity": "Identité",
        "orders": "Ordres",
        "reviews": "Commentaires",
        "stats": "Statistiques"
      }
    },
    "page": {
      "delete": "Effacer"
    },
    "products": {
      "fields": {
        "category_id": "Catégorie",
        "height": "Hauteur",
        "height_gte": "Hauteur minimale",
        "height_lte": "Hauteur maximale",
        "image": "Image",
        "price": "Prix",
        "reference": "Référence",
        "stock": "Stock",
        "stock_lte": "Stock faible",
        "thumbnail": "Vignette",
        "width": "Largeur",
        "width_gte": "Largeur minimale",
        "width_lte": "Largeur maximale"
      },
      "name": "Poster |||| Posters",
      "tabs": {
        "description": "Description",
        "details": "Détails",
        "image": "Image",
        "reviews": "Commentaires"
      }
    },
    "reviews": {
      "action": {
        "accept": "Accepter",
        "reject": "Rejeter"
      },
      "fields": {
        "command_id": "Ordre",
        "comment": "Commentaire",
        "customer_id": "Client",
        "date": "Date",
        "date_gte": "Posté depuis",
        "date_lte": "Posté avant",
        "product_id": "Produit",
        "rating": "Évaluation"
      },
      "name": "Commentaire |||| Commentaires",
      "notification": {
        "approved_error": "Erreur: avis non approuvé",
        "approved_success": "Avis approuvé",
        "rejected_error": "Erreur: avis non rejeté",
        "rejected_success": "Avis rejeté"
      }
    },
    "revisions": {
      "fields": {
        "entityId": "ID d'entité",
        "id": "Id",
        "name": "Npm",
        "nextBody": "Corps suivant",
        "prevBody": "Corps précédent",
        "resource": "Ressource",
        "reverted": "Inversé",
        "subtype": "Sous-type",
        "timestamp": "Horodatage",
        "type": "Type",
        "user": "Utilisateur"
      },
      "name": "Révision |||| Révisions"
    },
    "segments": {
      "data": {
        "collector": "Collectionneur",
        "compulsive": "Compulsif",
        "ordered_once": "Commandé une fois",
        "regular": "Ordinaire",
        "returns": "Résultats",
        "reviewer": "Critique"
      },
      "fields": {
        "customers": "Clients",
        "name": "Nom"
      },
      "name": "Segments"
    },
    "users": {
      "fields": {
        "createdAt": "Créé à",
        "education": "Education",
        "email": "Email",
        "karma": "Karma",
        "name": "Nom",
        "privilege": "Privilège",
        "username": "Nom d'utilisateur"
      },
      "name": "Utilisateur |||| Utilisateurs",
      "page": {
        "delete": "Supprimer le compte"
      },
      "tabs": {
        "address": "Adresse",
        "identity": "Identité",
        "orders": "Ordres",
        "reviews": "Commentaires",
        "stats": "Statistiques"
      }
    }
  },
  "somethingWentWrong": "Quelque chose a mal fonctionné"
}
